import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Home from './Pages/Home.jsx';
import Projects from './Pages/Projects.jsx';
import ProjectEditor from './Pages/ProjectEditor.jsx';
import Schedule from './Pages/Schedule.jsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<ProjectEditor />} />
          <Route path="/schedule" element={<Schedule />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
